import React, { useEffect, useState } from "react";
import Select from "react-select";
import LaboratoryService from "../../../../services/LaboratoireService";
export default function (props) {
  const { filters, setFilters } = props;
  const [options, setOptions] = useState([]);
  const [dentists_ids, setDentistsIds] = useState([]);
  const [dentists, setDentists] = useState([]);

  const userIdHandler = (value) => {
    let ids = [];
    value.map((sv) => {
      ids.push(sv.value);
    });
    setDentistsIds(ids);
    setFilters({
      ...filters,
      dentists: ids,
    });
  };
  const getDentists = async () => {
    try {
      const response = await LaboratoryService.Dentists();
      if (response.status === 200) {
        console.log("dentists list ===>", response.data.data);
        setDentists(response.data.data);
        let loptions = [];
        response.data.data.map((d) => {
          loptions.push({
            value: d.id,
            label: d.last_name + " " + d.first_name,
          });
        });
        setOptions(loptions);
      }
    } catch (err) {
      // console.log(err);
    }
  };

  useEffect(() => {
    getDentists();
  }, []);
  return (
    <>
      <div className="mt-2">
        <h4>Dentists </h4>
        <div className="mt-2">
          {options && options.length > 0 ? (
            <Select
              name="dentist"
              onChange={userIdHandler}
              options={options}
              isMulti
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  );
}
